export default [
  {
    cityName: '北京',
    cityNameTraditional: '北京',
    normalizedCityName: 'BeiJing',
    code: '2',
    postalCode: '100000',
    carrierCode: 'RUBO',
    hubCode: 'H522',
    leadTime: '3',
    leadTimeDays: '3 days',
    leadTimeAirHours: '36',
    province: '北京',
    region: '010'
  },
  {
    cityName: '上海',
    cityNameTraditional: '上海',
    normalizedCityName: 'ShangHai',
    code: '47',
    postalCode: '200000',
    carrierCode: 'YUHA',
    hubCode: 'H264',
    leadTime: '1',
    leadTimeDays: '1 day',
    leadTimeAirHours: '#N/A',
    province: '上海',
    region: '020'
  },
  {
    cityName: '广州',
    cityNameTraditional: '廣州',
    normalizedCityName: 'GuangZhou',
    code: '15',
    postalCode: '510000',
    carrierCode: 'HERC',
    hubCode: 'H157',
    leadTime: '3',
    leadTimeDays: '3 days',
    leadTimeAirHours: '36',
    province: '广东',
    region: '190'
  },
  {
    cityName: '安庆',
    cityNameTraditional: '安慶',
    normalizedCityName: 'Anqing',
    code: '126',
    postalCode: '246000',
    carrierCode: 'ROKN',
    hubCode: 'H249',
    leadTime: '3',
    leadTimeDays: '3 days',
    leadTimeAirHours: '48',
    province: '安徽',
    region: '110'
  },
  {
    cityName: '鞍山',
    cityNameTraditional: '鞍山',
    normalizedCityName: 'AnShan',
    code: '1',
    postalCode: '114000',
    carrierCode: 'RUBO',
    hubCode: 'H570',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '48',
    province: '辽宁',
    region: '070'
  },
  {
    cityName: '保定',
    cityNameTraditional: '保定',
    normalizedCityName: 'BaoDing',
    code: '86',
    postalCode: '071000',
    carrierCode: 'ROKN',
    hubCode: 'H527',
    leadTime: '3',
    leadTimeDays: '3 days',
    leadTimeAirHours: '48',
    province: '河北',
    region: '060'
  },
  {
    cityName: '包头',
    cityNameTraditional: '包頭',
    normalizedCityName: 'Baotou',
    code: '113',
    postalCode: '014000',
    carrierCode: 'RUBO',
    hubCode: 'H534',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '36',
    province: '内蒙古',
    region: '040'
  },
  {
    cityName: '北安',
    cityNameTraditional: '北安',
    normalizedCityName: 'Beian',
    code: '173',
    postalCode: '164000',
    carrierCode: 'RUBO',
    hubCode: 'H383',
    leadTime: '9',
    leadTimeDays: '9 days',
    leadTimeAirHours: '48',
    province: '黑龙江',
    region: '090'
  },
  {
    cityName: '北海',
    cityNameTraditional: '北海',
    normalizedCityName: 'Beihai',
    code: '112',
    postalCode: '536000',
    carrierCode: 'ROKN',
    hubCode: 'H175',
    leadTime: '6',
    leadTimeDays: '6 days',
    leadTimeAirHours: '48',
    province: '广西',
    region: '210'
  },
  {
    cityName: '蚌埠',
    cityNameTraditional: '蚌埠',
    normalizedCityName: 'Bengbu',
    code: '135',
    postalCode: '233000',
    carrierCode: 'ROKN',
    hubCode: 'H250',
    leadTime: '2',
    leadTimeDays: '2 days',
    leadTimeAirHours: '#N/A',
    province: '安徽',
    region: '110'
  },
  {
    cityName: '长春',
    cityNameTraditional: '長春',
    normalizedCityName: 'ChangChun',
    code: '3',
    postalCode: '130000',
    carrierCode: 'RUBO',
    hubCode: 'H567',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '36',
    province: '吉林',
    region: '080'
  },
  {
    cityName: '长沙',
    cityNameTraditional: '長沙',
    normalizedCityName: 'ChangSha',
    code: '4',
    postalCode: '410000',
    carrierCode: 'ROKN',
    hubCode: 'H587',
    leadTime: '3',
    leadTimeDays: '3 days',
    leadTimeAirHours: '36',
    province: '湖南',
    region: '160'
  },
  {
    cityName: '常熟',
    cityNameTraditional: '常熟',
    normalizedCityName: 'ChangShu',
    code: '88',
    postalCode: '215500',
    carrierCode: 'HERC',
    hubCode: 'H259',
    leadTime: '1',
    leadTimeDays: '1 day',
    leadTimeAirHours: '#N/A',
    province: '江苏',
    region: '100'
  },
  {
    cityName: '常州',
    cityNameTraditional: '常州',
    normalizedCityName: 'ChangZhou',
    code: '5',
    postalCode: '213000',
    carrierCode: 'HERC',
    hubCode: 'H251',
    leadTime: '1',
    leadTimeDays: '1 day',
    leadTimeAirHours: '#N/A',
    province: '江苏',
    region: '100'
  },
  {
    cityName: '朝阳',
    cityNameTraditional: '朝陽',
    normalizedCityName: 'ChaoYang',
    code: '96',
    postalCode: '122600',
    carrierCode: 'RUBO',
    hubCode: 'H576',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '48',
    province: '辽宁',
    region: '070'
  },
  {
    cityName: '潮州',
    cityNameTraditional: '潮州',
    normalizedCityName: 'ChaoZhou',
    code: '6',
    postalCode: '521000',
    carrierCode: 'HERC',
    hubCode: 'H154',
    leadTime: '6',
    leadTimeDays: '6 days',
    leadTimeAirHours: '48',
    province: '广东',
    region: '190'
  },
  {
    cityName: '承德',
    cityNameTraditional: '承德',
    normalizedCityName: 'ChengDe',
    code: '142',
    postalCode: '067000',
    carrierCode: 'ROKN',
    hubCode: 'H291',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '河北',
    region: '060'
  },
  {
    cityName: '成都',
    cityNameTraditional: '成都',
    normalizedCityName: 'ChengDu',
    code: '7',
    postalCode: '610000',
    carrierCode: 'HERC',
    hubCode: 'H318',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '36',
    province: '四川',
    region: '230'
  },
  {
    cityName: '郴州',
    cityNameTraditional: '郴州',
    normalizedCityName: 'Chenzhou',
    code: '132',
    postalCode: '423000',
    carrierCode: 'ROKN',
    hubCode: 'H592',
    leadTime: '6',
    leadTimeDays: '6 days',
    leadTimeAirHours: '48',
    province: '湖南',
    region: '160'
  },
  {
    cityName: '赤峰',
    cityNameTraditional: '赤峰',
    normalizedCityName: 'Chifeng',
    code: '138',
    postalCode: '024000',
    carrierCode: 'RUBO',
    hubCode: 'H287',
    leadTime: '7',
    leadTimeDays: '7 days',
    leadTimeAirHours: '48',
    province: '内蒙古',
    region: '040'
  },
  {
    cityName: '重庆',
    cityNameTraditional: '重慶',
    normalizedCityName: 'ChongQing',
    code: '8',
    postalCode: '400000',
    carrierCode: 'HERC',
    hubCode: 'H311',
    leadTime: '6',
    leadTimeDays: '6 days',
    leadTimeAirHours: '36',
    province: '重庆',
    region: '320'
  },
  {
    cityName: '慈溪',
    cityNameTraditional: '慈溪',
    normalizedCityName: 'Cixi',
    code: '124',
    postalCode: '315300',
    carrierCode: 'RUBO',
    hubCode: 'H282',
    leadTime: '2',
    leadTimeDays: '2 days',
    leadTimeAirHours: '#N/A',
    province: '浙江',
    region: '130'
  },
  {
    cityName: '大连',
    cityNameTraditional: '大連',
    normalizedCityName: 'DaLian',
    code: '9',
    postalCode: '116000',
    carrierCode: 'RUBO',
    hubCode: 'H571',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '36',
    province: '辽宁',
    region: '070'
  },
  {
    cityName: '大庆',
    cityNameTraditional: '大慶',
    normalizedCityName: 'DaQing',
    code: '10',
    postalCode: '163000',
    carrierCode: 'RUBO',
    hubCode: 'H561',
    leadTime: '6',
    leadTimeDays: '6 days',
    leadTimeAirHours: '48',
    province: '黑龙江',
    region: '090'
  },
  {
    cityName: '大同',
    cityNameTraditional: '大同',
    normalizedCityName: 'Datong',
    code: '129',
    postalCode: '037000',
    carrierCode: 'ROKN',
    hubCode: 'H546',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '48',
    province: '山西',
    region: '050'
  },
  {
    cityName: '德州',
    cityNameTraditional: '德州',
    normalizedCityName: 'Dezhou',
    code: '182',
    postalCode: '253000',
    carrierCode: 'ROKN',
    hubCode: 'H390',
    leadTime: '3',
    leadTimeDays: '3 days',
    leadTimeAirHours: '48',
    province: '山东',
    region: '120'
  },
  {
    cityName: '东莞',
    cityNameTraditional: '東莞',
    normalizedCityName: 'DongGuan',
    code: '11',
    postalCode: '511700',
    carrierCode: 'HERC',
    hubCode: 'H155',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '广东',
    region: '190'
  },
  {
    cityName: '东营',
    cityNameTraditional: '東營',
    normalizedCityName: 'DongYing',
    code: '12',
    postalCode: '257000',
    carrierCode: 'ROKN',
    hubCode: 'H538',
    leadTime: '3',
    leadTimeDays: '3 days',
    leadTimeAirHours: '48',
    province: '山东',
    region: '120'
  },
  {
    cityName: '鄂州',
    cityNameTraditional: '鄂州',
    normalizedCityName: 'Ezhou',
    code: '180',
    postalCode: '436000',
    carrierCode: 'YUHA',
    hubCode: 'H399',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '湖北',
    region: '170'
  },
  {
    cityName: '佛山',
    cityNameTraditional: '佛山',
    normalizedCityName: 'FoShan',
    code: '13',
    postalCode: '528000',
    carrierCode: 'HERC',
    hubCode: 'H156',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '广东',
    region: '190'
  },
  {
    cityName: '福安',
    cityNameTraditional: '福安',
    normalizedCityName: 'Fuan',
    code: '118',
    postalCode: '355000',
    carrierCode: 'ROKN',
    hubCode: 'H586',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '48',
    province: '福建',
    region: '150'
  },
  {
    cityName: '抚顺',
    cityNameTraditional: '撫順',
    normalizedCityName: 'Fushun',
    code: '134',
    postalCode: '113000',
    carrierCode: 'RUBO',
    hubCode: 'H578',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '48',
    province: '辽宁',
    region: '070'
  },
  {
    cityName: '阜新',
    cityNameTraditional: '阜新',
    normalizedCityName: 'FuXin',
    code: '89',
    postalCode: '123000',
    carrierCode: 'RUBO',
    hubCode: 'H575',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '48',
    province: '辽宁',
    region: '070'
  },
  {
    cityName: '富阳',
    cityNameTraditional: '富陽',
    normalizedCityName: 'Fuyang',
    code: '123',
    postalCode: '311400',
    carrierCode: 'RUBO',
    hubCode: 'H281',
    leadTime: '2',
    leadTimeDays: '2 days',
    leadTimeAirHours: '#N/A',
    province: '浙江',
    region: '130'
  },
  {
    cityName: '福州',
    cityNameTraditional: '福州',
    normalizedCityName: 'FuZhou',
    code: '14',
    postalCode: '350000',
    carrierCode: 'ROKN',
    hubCode: 'H579',
    leadTime: '3',
    leadTimeDays: '3 days',
    leadTimeAirHours: '36',
    province: '福建',
    region: '150'
  },
  {
    cityName: '高碑店',
    cityNameTraditional: '高碑店',
    normalizedCityName: 'GaoBeiDian',
    code: '90',
    postalCode: '074000',
    carrierCode: 'ROKN',
    hubCode: 'H528',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '48',
    province: '河北',
    region: '060'
  },
  {
    cityName: '桂林',
    cityNameTraditional: '桂林',
    normalizedCityName: 'GuiLin',
    code: '16',
    postalCode: '541000',
    carrierCode: 'ROKN',
    hubCode: 'H172',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '36',
    province: '广西',
    region: '210'
  },
  {
    cityName: '贵阳',
    cityNameTraditional: '貴陽',
    normalizedCityName: 'GuiYang',
    code: '17',
    postalCode: '550000',
    carrierCode: 'YUHA',
    hubCode: 'H245',
    leadTime: '6',
    leadTimeDays: '6 days',
    leadTimeAirHours: '36',
    province: '贵州',
    region: '220'
  },
  {
    cityName: '哈尔滨',
    cityNameTraditional: '哈爾濱',
    normalizedCityName: 'HaErBin',
    code: '18',
    postalCode: '150000',
    carrierCode: 'RUBO',
    hubCode: 'H562',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '36',
    province: '黑龙江',
    region: '090'
  },
  {
    cityName: '海口',
    cityNameTraditional: '海口',
    normalizedCityName: 'HaiKou',
    code: '19',
    postalCode: '570000',
    carrierCode: 'HERC',
    hubCode: 'H176',
    leadTime: '6',
    leadTimeDays: '6 days',
    leadTimeAirHours: '36',
    province: '海南',
    region: '200'
  },
  {
    cityName: '海宁',
    cityNameTraditional: '海寧',
    normalizedCityName: 'HaiNing',
    code: '146',
    postalCode: '314400',
    carrierCode: 'RUBO',
    hubCode: 'H295',
    leadTime: '2',
    leadTimeDays: '2 days',
    leadTimeAirHours: '#N/A',
    province: '浙江',
    region: '130'
  },
  {
    cityName: '哈密',
    cityNameTraditional: '哈密',
    normalizedCityName: 'Hami',
    code: '139',
    postalCode: '839000',
    carrierCode: 'RUBO',
    hubCode: 'H288',
    leadTime: '9',
    leadTimeDays: '9 days',
    leadTimeAirHours: '48',
    province: '新疆',
    region: '290'
  },
  {
    cityName: '邯郸',
    cityNameTraditional: '邯鄲',
    normalizedCityName: 'Handan',
    code: '179',
    postalCode: '056000',
    carrierCode: 'ROKN',
    hubCode: 'H398',
    leadTime: '3',
    leadTimeDays: '3 days',
    leadTimeAirHours: '48',
    province: '河北',
    region: '060'
  },
  {
    cityName: '杭州',
    cityNameTraditional: '杭州',
    normalizedCityName: 'HangZhou',
    code: '20',
    postalCode: '310000',
    carrierCode: 'RUBO',
    hubCode: 'H265',
    leadTime: '1',
    leadTimeDays: '1 day',
    leadTimeAirHours: '#N/A',
    province: '浙江',
    region: '130'
  },
  {
    cityName: '合肥',
    cityNameTraditional: '合肥',
    normalizedCityName: 'HeFei',
    code: '21',
    postalCode: '230000',
    carrierCode: 'ROKN',
    hubCode: 'H246',
    leadTime: '2',
    leadTimeDays: '2 days',
    leadTimeAirHours: '#N/A',
    province: '安徽',
    region: '110'
  },
  {
    cityName: '衡阳',
    cityNameTraditional: '衡陽',
    normalizedCityName: 'Hengyang',
    code: '131',
    postalCode: '421000',
    carrierCode: 'ROKN',
    hubCode: 'H591',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '48',
    province: '湖南',
    region: '160'
  },
  {
    cityName: '淮安',
    cityNameTraditional: '淮安',
    normalizedCityName: 'Huaian',
    code: '140',
    postalCode: '223200',
    carrierCode: 'HERC',
    hubCode: 'H290',
    leadTime: '2',
    leadTimeDays: '2 days',
    leadTimeAirHours: '#N/A',
    province: '江苏',
    region: '100'
  },
  {
    cityName: '淮南',
    cityNameTraditional: '淮南',
    normalizedCityName: 'Huainan',
    code: '120',
    postalCode: '232000',
    carrierCode: 'ROKN',
    hubCode: 'H248',
    leadTime: '2',
    leadTimeDays: '2 days',
    leadTimeAirHours: '#N/A',
    province: '安徽',
    region: '110'
  },
  {
    cityName: '黄石',
    cityNameTraditional: '黃石',
    normalizedCityName: 'Huangshi',
    code: '168',
    postalCode: '435000',
    carrierCode: 'YUHA',
    hubCode: 'H377',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '湖北',
    region: '170'
  },
  {
    cityName: '呼和浩特',
    cityNameTraditional: '呼和浩特',
    normalizedCityName: 'HuHeHaoTe',
    code: '22',
    postalCode: '010000',
    carrierCode: 'RUBO',
    hubCode: 'H531',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '36',
    province: '内蒙古',
    region: '040'
  },
  {
    cityName: '惠州',
    cityNameTraditional: '惠州',
    normalizedCityName: 'HuiZhou',
    code: '24',
    postalCode: '516000',
    carrierCode: 'HERC',
    hubCode: 'H159',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '48',
    province: '广东',
    region: '190'
  },
  {
    cityName: '葫芦岛',
    cityNameTraditional: '葫蘆島',
    normalizedCityName: 'Huludao',
    code: '164',
    postalCode: '125000',
    carrierCode: 'RUBO',
    hubCode: 'H374',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '48',
    province: '辽宁',
    region: '070'
  },
  {
    cityName: '湖州',
    cityNameTraditional: '湖州',
    normalizedCityName: 'HuZhou',
    code: '101',
    postalCode: '313000',
    carrierCode: 'RUBO',
    hubCode: 'H286',
    leadTime: '2',
    leadTimeDays: '2 days',
    leadTimeAirHours: '#N/A',
    province: '浙江',
    region: '130'
  },
  {
    cityName: '佳木斯',
    cityNameTraditional: '佳木斯',
    normalizedCityName: 'JiaMuSi',
    code: '25',
    postalCode: '154000',
    carrierCode: 'RUBO',
    hubCode: 'H563',
    leadTime: '6',
    leadTimeDays: '6 days',
    leadTimeAirHours: '48',
    province: '黑龙江',
    region: '090'
  },
  {
    cityName: '江门',
    cityNameTraditional: '江門',
    normalizedCityName: 'JiangMen',
    code: '104',
    postalCode: '529000',
    carrierCode: 'HERC',
    hubCode: 'H170',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '广东',
    region: '190'
  },
  {
    cityName: '江阴',
    cityNameTraditional: '江陰',
    normalizedCityName: 'Jiangyin',
    code: '158',
    postalCode: '214400',
    carrierCode: 'HERC',
    hubCode: 'H367',
    leadTime: '1',
    leadTimeDays: '1 day',
    leadTimeAirHours: '#N/A',
    province: '江苏',
    region: '100'
  },
  {
    cityName: '嘉善',
    cityNameTraditional: '嘉善',
    normalizedCityName: 'Jiashan',
    code: '162',
    postalCode: '314100',
    carrierCode: 'RUBO',
    hubCode: 'H371',
    leadTime: '2',
    leadTimeDays: '2 days',
    leadTimeAirHours: '#N/A',
    province: '浙江',
    region: '130'
  },
  {
    cityName: '嘉兴',
    cityNameTraditional: '嘉興',
    normalizedCityName: 'Jiaxing',
    code: '122',
    postalCode: '314000',
    carrierCode: 'RUBO',
    hubCode: 'H280',
    leadTime: '1',
    leadTimeDays: '1 day',
    leadTimeAirHours: '#N/A',
    province: '浙江',
    region: '130'
  },
  {
    cityName: '吉林',
    cityNameTraditional: '吉林',
    normalizedCityName: 'JiLin',
    code: '26',
    postalCode: '132000',
    carrierCode: 'RUBO',
    hubCode: 'H568',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '48',
    province: '吉林',
    region: '080'
  },
  {
    cityName: '济南',
    cityNameTraditional: '濟南',
    normalizedCityName: 'JiNan',
    code: '27',
    postalCode: '250000',
    carrierCode: 'ROKN',
    hubCode: 'H539',
    leadTime: '2',
    leadTimeDays: '2 days',
    leadTimeAirHours: '#N/A',
    province: '山东',
    region: '120'
  },
  {
    cityName: '景洪',
    cityNameTraditional: '景洪',
    normalizedCityName: 'Jinghong',
    code: '157',
    postalCode: '666100',
    carrierCode: 'YUHA',
    hubCode: 'H365',
    leadTime: '11',
    leadTimeDays: '11 days',
    leadTimeAirHours: '48',
    province: '云南',
    region: '240'
  },
  {
    cityName: '荆州',
    cityNameTraditional: '荊州',
    normalizedCityName: 'JingZhou',
    code: '28',
    postalCode: '434000',
    carrierCode: 'YUHA',
    hubCode: 'H312',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '湖北',
    region: '170'
  },
  {
    cityName: '金华',
    cityNameTraditional: '金華',
    normalizedCityName: 'JinHua',
    code: '29',
    postalCode: '321000',
    carrierCode: 'RUBO',
    hubCode: 'H266',
    leadTime: '1',
    leadTimeDays: '1 day',
    leadTimeAirHours: '#N/A',
    province: '浙江',
    region: '130'
  },
  {
    cityName: '济宁',
    cityNameTraditional: '濟寧',
    normalizedCityName: 'Jining',
    code: '145',
    postalCode: '272000',
    carrierCode: 'ROKN',
    hubCode: 'H294',
    leadTime: '3',
    leadTimeDays: '3 days',
    leadTimeAirHours: '48',
    province: '山东',
    region: '120'
  },
  {
    cityName: '晋江',
    cityNameTraditional: '晉江',
    normalizedCityName: 'JinJiang',
    code: '106',
    postalCode: '362200',
    carrierCode: 'ROKN',
    hubCode: 'H584',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '福建',
    region: '150'
  },
  {
    cityName: '缙云',
    cityNameTraditional: '縉雲',
    normalizedCityName: 'JinYun',
    code: '102',
    postalCode: '321400',
    carrierCode: 'RUBO',
    hubCode: 'H277',
    leadTime: '3',
    leadTimeDays: '3 days',
    leadTimeAirHours: '48',
    province: '浙江',
    region: '130'
  },
  {
    cityName: '锦州',
    cityNameTraditional: '錦州',
    normalizedCityName: 'JinZhou',
    code: '30',
    postalCode: '121000',
    carrierCode: 'RUBO',
    hubCode: 'H572',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '48',
    province: '辽宁',
    region: '070'
  },
  {
    cityName: '九江',
    cityNameTraditional: '九江',
    normalizedCityName: 'Jiujiang',
    code: '178',
    postalCode: '332000',
    carrierCode: 'ROKN',
    hubCode: 'H411',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '江西',
    region: '140'
  },
  {
    cityName: '开原',
    cityNameTraditional: '開原',
    normalizedCityName: 'Kaiyuan',
    code: '167',
    postalCode: '112300',
    carrierCode: 'RUBO',
    hubCode: 'H378',
    leadTime: '6',
    leadTimeDays: '6 days',
    leadTimeAirHours: '48',
    province: '辽宁',
    region: '070'
  },
  {
    cityName: '喀什',
    cityNameTraditional: '喀什',
    normalizedCityName: 'Kashi',
    code: '',
    postalCode: '843800',
    carrierCode: 'RUBO',
    hubCode: 'H629',
    leadTime: '',
    leadTimeDays: '',
    leadTimeAirHours: '',
    province: '新疆',
    region: '290'
  },
  {
    cityName: '库尔勒',
    cityNameTraditional: '庫爾勒',
    normalizedCityName: 'Korla',
    code: '',
    postalCode: '841500',
    carrierCode: 'RUBO',
    hubCode: 'H630',
    leadTime: '',
    leadTimeDays: '',
    leadTimeAirHours: '',
    province: '新疆',
    region: '290'
  },
  {
    cityName: '昆明',
    cityNameTraditional: '昆明',
    normalizedCityName: 'KunMing',
    code: '31',
    postalCode: '650000',
    carrierCode: 'YUHA',
    hubCode: 'H319',
    leadTime: '6',
    leadTimeDays: '6 days',
    leadTimeAirHours: '36',
    province: '云南',
    region: '240'
  },
  {
    cityName: '昆山',
    cityNameTraditional: '崑山',
    normalizedCityName: 'KunShan',
    code: '32',
    postalCode: '215300',
    carrierCode: 'HERC',
    hubCode: 'H252',
    leadTime: '1',
    leadTimeDays: '1 day',
    leadTimeAirHours: '#N/A',
    province: '江苏',
    region: '100'
  },
  {
    cityName: '廊坊',
    cityNameTraditional: '廊坊',
    normalizedCityName: 'LangFang',
    code: '98',
    postalCode: '065000',
    carrierCode: 'ROKN',
    hubCode: 'H529',
    leadTime: '3',
    leadTimeDays: '3 days',
    leadTimeAirHours: '48',
    province: '河北',
    region: '060'
  },
  {
    cityName: '兰州',
    cityNameTraditional: '蘭州',
    normalizedCityName: 'LanZhou',
    code: '33',
    postalCode: '730000',
    carrierCode: 'RUBO',
    hubCode: 'H523',
    leadTime: '6',
    leadTimeDays: '6 days',
    leadTimeAirHours: '36',
    province: '甘肃',
    region: '260'
  },
  {
    cityName: '乐清',
    cityNameTraditional: '樂清',
    normalizedCityName: 'LeQing',
    code: '87',
    postalCode: '325600',
    carrierCode: 'RUBO',
    hubCode: 'H275',
    leadTime: '3',
    leadTimeDays: '3 days',
    leadTimeAirHours: '#N/A',
    province: '浙江',
    region: '130'
  },
  {
    cityName: '连云港',
    cityNameTraditional: '連雲港',
    normalizedCityName: 'LianYunGang',
    code: '93',
    postalCode: '222000',
    carrierCode: 'HERC',
    hubCode: 'H261',
    leadTime: '2',
    leadTimeDays: '2 days',
    leadTimeAirHours: '#N/A',
    province: '江苏',
    region: '100'
  },
  {
    cityName: '辽阳',
    cityNameTraditional: '遼陽',
    normalizedCityName: 'LiaoYang',
    code: '97',
    postalCode: '111000',
    carrierCode: 'RUBO',
    hubCode: 'H577',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '48',
    province: '辽宁',
    region: '070'
  },
  {
    cityName: '丽江',
    cityNameTraditional: '麗江',
    normalizedCityName: 'Lijiang',
    code: '161',
    postalCode: '674100',
    carrierCode: 'YUHA',
    hubCode: 'H370',
    leadTime: '7',
    leadTimeDays: '7 days',
    leadTimeAirHours: '48',
    province: '云南',
    region: '240'
  },
  {
    cityName: '临海',
    cityNameTraditional: '臨海',
    normalizedCityName: 'LinHai',
    code: '34',
    postalCode: '317000',
    carrierCode: 'RUBO',
    hubCode: 'H267',
    leadTime: '2',
    leadTimeDays: '2 days',
    leadTimeAirHours: '#N/A',
    province: '浙江',
    region: '130'
  },
  {
    cityName: '临沂',
    cityNameTraditional: '臨沂',
    normalizedCityName: 'Linyi',
    code: '159',
    postalCode: '276000',
    carrierCode: 'ROKN',
    hubCode: 'H368',
    leadTime: '3',
    leadTimeDays: '3 days',
    leadTimeAirHours: '48',
    province: '山东',
    region: '120'
  },
  {
    cityName: '丽水',
    cityNameTraditional: '麗水',
    normalizedCityName: 'LiShui',
    code: '35',
    postalCode: '323000',
    carrierCode: 'RUBO',
    hubCode: 'H268',
    leadTime: '2',
    leadTimeDays: '2 days',
    leadTimeAirHours: '#N/A',
    province: '浙江',
    region: '130'
  },
  {
    cityName: '柳州',
    cityNameTraditional: '柳州',
    normalizedCityName: 'LiuZhou',
    code: '36',
    postalCode: '545000',
    carrierCode: 'ROKN',
    hubCode: 'H173',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '36',
    province: '广西',
    region: '210'
  },
  {
    cityName: '洛阳',
    cityNameTraditional: '洛陽',
    normalizedCityName: 'LuoYang',
    code: '100',
    postalCode: '471000',
    carrierCode: 'ROKN',
    hubCode: 'H284',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '河南',
    region: '180'
  },
  {
    cityName: '潞西',
    cityNameTraditional: '潞西',
    normalizedCityName: 'Luxi',
    code: '149',
    postalCode: '678400',
    carrierCode: 'YUHA',
    hubCode: 'H298',
    leadTime: '11',
    leadTimeDays: '11 days',
    leadTimeAirHours: '48',
    province: '云南',
    region: '240'
  },
  {
    cityName: '马鞍山',
    cityNameTraditional: '馬鞍山',
    normalizedCityName: 'Maanshan',
    code: '174',
    postalCode: '243000',
    carrierCode: 'ROKN',
    hubCode: 'H384',
    leadTime: '2',
    leadTimeDays: '2 days',
    leadTimeAirHours: '#N/A',
    province: '安徽',
    region: '110'
  },
  {
    cityName: '满洲里',
    cityNameTraditional: '滿洲里',
    normalizedCityName: 'ManZhouLi',
    code: '109',
    postalCode: '021400',
    carrierCode: 'RUBO',
    hubCode: 'H532',
    leadTime: '7',
    leadTimeDays: '7 days',
    leadTimeAirHours: '48',
    province: '内蒙古',
    region: '040'
  },
  {
    cityName: '茂名',
    cityNameTraditional: '茂名',
    normalizedCityName: 'MaoMing',
    code: '37',
    postalCode: '525000',
    carrierCode: 'HERC',
    hubCode: 'H160',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '广东',
    region: '190'
  },
  {
    cityName: '梅州',
    cityNameTraditional: '梅州',
    normalizedCityName: 'Meizhou',
    code: '172',
    postalCode: '514000',
    carrierCode: 'HERC',
    hubCode: 'H382',
    leadTime: '6',
    leadTimeDays: '6 days',
    leadTimeAirHours: '48',
    province: '广东',
    region: '190'
  },
  {
    cityName: '蒙自',
    cityNameTraditional: '蒙自',
    normalizedCityName: 'MengZi',
    code: '111',
    postalCode: '661100',
    carrierCode: 'YUHA',
    hubCode: 'H320',
    leadTime: '11',
    leadTimeDays: '11 days',
    leadTimeAirHours: '60',
    province: '云南',
    region: '240'
  },
  {
    cityName: '绵阳',
    cityNameTraditional: '綿陽',
    normalizedCityName: 'Mianyang',
    code: '160',
    postalCode: '621000',
    carrierCode: 'HERC',
    hubCode: 'H369',
    leadTime: '6',
    leadTimeDays: '6 days',
    leadTimeAirHours: '48',
    province: '四川',
    region: '230'
  },
  {
    cityName: '牡丹江',
    cityNameTraditional: '牡丹江',
    normalizedCityName: 'MuDanJiang',
    code: '38',
    postalCode: '157000',
    carrierCode: 'RUBO',
    hubCode: 'H564',
    leadTime: '6',
    leadTimeDays: '6 days',
    leadTimeAirHours: '48',
    province: '黑龙江',
    region: '090'
  },
  {
    cityName: '南昌',
    cityNameTraditional: '南昌',
    normalizedCityName: 'NanChang',
    code: '39',
    postalCode: '330000',
    carrierCode: 'ROKN',
    hubCode: 'H410',
    leadTime: '2',
    leadTimeDays: '2 days',
    leadTimeAirHours: '#N/A',
    province: '江西',
    region: '140'
  },
  {
    cityName: '南京',
    cityNameTraditional: '南京',
    normalizedCityName: 'NanJing',
    code: '40',
    postalCode: '210000',
    carrierCode: 'HERC',
    hubCode: 'H253',
    leadTime: '1',
    leadTimeDays: '1 day',
    leadTimeAirHours: '#N/A',
    province: '江苏',
    region: '100'
  },
  {
    cityName: '南宁',
    cityNameTraditional: '南寧',
    normalizedCityName: 'NanNing',
    code: '41',
    postalCode: '530000',
    carrierCode: 'ROKN',
    hubCode: 'H174',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '36',
    province: '广西',
    region: '210'
  },
  {
    cityName: '南通',
    cityNameTraditional: '南通',
    normalizedCityName: 'NanTong',
    code: '92',
    postalCode: '226000',
    carrierCode: 'HERC',
    hubCode: 'H260',
    leadTime: '1',
    leadTimeDays: '1 day',
    leadTimeAirHours: '#N/A',
    province: '江苏',
    region: '100'
  },
  {
    cityName: '南阳',
    cityNameTraditional: '南陽',
    normalizedCityName: 'Nanyang',
    code: '152',
    postalCode: '473000',
    carrierCode: 'ROKN',
    hubCode: 'H361',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '河南',
    region: '180'
  },
  {
    cityName: '宁波',
    cityNameTraditional: '寧波',
    normalizedCityName: 'NingBo',
    code: '42',
    postalCode: '315000',
    carrierCode: 'RUBO',
    hubCode: 'H269',
    leadTime: '1',
    leadTimeDays: '1 day',
    leadTimeAirHours: '#N/A',
    province: '浙江',
    region: '130'
  },
  {
    cityName: '宁德',
    cityNameTraditional: '寧德',
    normalizedCityName: 'Ningde',
    code: '156',
    postalCode: '352100',
    carrierCode: 'ROKN',
    hubCode: 'H366',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '48',
    province: '福建',
    region: '150'
  },
  {
    cityName: '盘锦',
    cityNameTraditional: '盤錦',
    normalizedCityName: 'Panjin',
    code: '177',
    postalCode: '124000',
    carrierCode: 'RUBO',
    hubCode: 'H388',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '48',
    province: '辽宁',
    region: '070'
  },
  {
    cityName: '番禺',
    cityNameTraditional: '番禺',
    normalizedCityName: 'PanYu',
    code: '43',
    postalCode: '511400',
    carrierCode: 'HERC',
    hubCode: 'H161',
    leadTime: '3',
    leadTimeDays: '3 days',
    leadTimeAirHours: '48',
    province: '广东',
    region: '190'
  },
  {
    cityName: '彭州',
    cityNameTraditional: '彭州',
    normalizedCityName: 'Pengzhou',
    code: '155',
    postalCode: '611900',
    carrierCode: 'HERC',
    hubCode: 'H364',
    leadTime: '6',
    leadTimeDays: '6 days',
    leadTimeAirHours: '48',
    province: '四川',
    region: '230'
  },
  {
    cityName: '莆田',
    cityNameTraditional: '莆田',
    normalizedCityName: 'PuTian',
    code: '44',
    postalCode: '351100',
    carrierCode: 'ROKN',
    hubCode: 'H580',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '福建',
    region: '150'
  },
  {
    cityName: '潜江',
    cityNameTraditional: '潛江',
    normalizedCityName: 'Qianjiang',
    code: '117',
    postalCode: '433100',
    carrierCode: 'YUHA',
    hubCode: 'H316',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '湖北',
    region: '170'
  },
  {
    cityName: '青岛',
    cityNameTraditional: '青島',
    normalizedCityName: 'QingDao',
    code: '45',
    postalCode: '266000',
    carrierCode: 'ROKN',
    hubCode: 'H540',
    leadTime: '3',
    leadTimeDays: '3 days',
    leadTimeAirHours: '36',
    province: '山东',
    region: '120'
  },
  {
    cityName: '清远',
    cityNameTraditional: '清遠',
    normalizedCityName: 'QingYuan',
    code: '105',
    postalCode: '511500',
    carrierCode: 'HERC',
    hubCode: 'H171',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '48',
    province: '广东',
    region: '190'
  },
  {
    cityName: '秦皇岛',
    cityNameTraditional: '秦皇島',
    normalizedCityName: 'QinHuangDao',
    code: '46',
    postalCode: '066000',
    carrierCode: 'ROKN',
    hubCode: 'H524',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '河北',
    region: '060'
  },
  {
    cityName: '钦州',
    cityNameTraditional: '欽州',
    normalizedCityName: 'Qinzhou',
    code: '175',
    postalCode: '535000',
    carrierCode: 'ROKN',
    hubCode: 'H386',
    leadTime: '6',
    leadTimeDays: '6 days',
    leadTimeAirHours: '48',
    province: '广西',
    region: '210'
  },
  {
    cityName: '齐齐哈尔',
    cityNameTraditional: '齊齊哈爾',
    normalizedCityName: 'QiQiHaEr',
    code: '94',
    postalCode: '161000',
    carrierCode: 'RUBO',
    hubCode: 'H565',
    leadTime: '6',
    leadTimeDays: '6 days',
    leadTimeAirHours: '48',
    province: '黑龙江',
    region: '090'
  },
  {
    cityName: '泉州',
    cityNameTraditional: '泉州',
    normalizedCityName: 'Quanzhou',
    code: '115',
    postalCode: '362000',
    carrierCode: 'ROKN',
    hubCode: 'H585',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '福建',
    region: '150'
  },
  {
    cityName: '瑞安',
    cityNameTraditional: '瑞安',
    normalizedCityName: 'RuiAn',
    code: '103',
    postalCode: '325200',
    carrierCode: 'RUBO',
    hubCode: 'H278',
    leadTime: '2',
    leadTimeDays: '2 days',
    leadTimeAirHours: '#N/A',
    province: '浙江',
    region: '130'
  },
  {
    cityName: '三亚',
    cityNameTraditional: '三亞',
    normalizedCityName: 'SanYa',
    code: '107',
    postalCode: '572000',
    carrierCode: 'HERC',
    hubCode: 'H177',
    leadTime: '7',
    leadTimeDays: '7 days',
    leadTimeAirHours: '36',
    province: '海南',
    region: '200'
  },
  {
    cityName: '上虞',
    cityNameTraditional: '上虞',
    normalizedCityName: 'ShangYu',
    code: '48',
    postalCode: '312300',
    carrierCode: 'RUBO',
    hubCode: 'H270',
    leadTime: '2',
    leadTimeDays: '2 days',
    leadTimeAirHours: '#N/A',
    province: '浙江',
    region: '130'
  },
  {
    cityName: '汕头',
    cityNameTraditional: '汕頭',
    normalizedCityName: 'ShanTou',
    code: '85',
    postalCode: '515000',
    carrierCode: 'HERC',
    hubCode: 'H169',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '广东',
    region: '190'
  },
  {
    cityName: '绍兴',
    cityNameTraditional: '紹興',
    normalizedCityName: 'Shaoxing',
    code: '121',
    postalCode: '312000',
    carrierCode: 'RUBO',
    hubCode: 'H279',
    leadTime: '1',
    leadTimeDays: '1 day',
    leadTimeAirHours: '#N/A',
    province: '浙江',
    region: '130'
  },
  {
    cityName: '沈阳',
    cityNameTraditional: '瀋陽',
    normalizedCityName: 'ShenYang',
    code: '49',
    postalCode: '110000',
    carrierCode: 'RUBO',
    hubCode: 'H573',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '36',
    province: '辽宁',
    region: '070'
  },
  {
    cityName: '深圳',
    cityNameTraditional: '深圳',
    normalizedCityName: 'ShenZhen',
    code: '50',
    postalCode: '518000',
    carrierCode: 'HERC',
    hubCode: 'H162',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '36',
    province: '广东',
    region: '190'
  },
  {
    cityName: '石家庄',
    cityNameTraditional: '石家莊',
    normalizedCityName: 'ShiJiaZhuang',
    code: '51',
    postalCode: '050000',
    carrierCode: 'ROKN',
    hubCode: 'H525',
    leadTime: '3',
    leadTimeDays: '3 days',
    leadTimeAirHours: '36',
    province: '河北',
    region: '060'
  },
  {
    cityName: '石狮',
    cityNameTraditional: '石獅',
    normalizedCityName: 'ShiShi',
    code: '52',
    postalCode: '362700',
    carrierCode: 'ROKN',
    hubCode: 'H581',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '福建',
    region: '150'
  },
  {
    cityName: '顺德',
    cityNameTraditional: '順德',
    normalizedCityName: 'ShunDe',
    code: '53',
    postalCode: '528300',
    carrierCode: 'HERC',
    hubCode: 'H163',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '广东',
    region: '190'
  },
  {
    cityName: '绥化',
    cityNameTraditional: '綏化',
    normalizedCityName: 'Suihua',
    code: '170',
    postalCode: '152000',
    carrierCode: 'RUBO',
    hubCode: 'H380',
    leadTime: '8',
    leadTimeDays: '8 days',
    leadTimeAirHours: '48',
    province: '黑龙江',
    region: '090'
  },
  {
    cityName: '宿迁',
    cityNameTraditional: '宿遷',
    normalizedCityName: 'Suqian',
    code: '163',
    postalCode: '223800',
    carrierCode: 'HERC',
    hubCode: 'H372',
    leadTime: '2',
    leadTimeDays: '2 days',
    leadTimeAirHours: '#N/A',
    province: '江苏',
    region: '100'
  },
  {
    cityName: '苏州',
    cityNameTraditional: '蘇州',
    normalizedCityName: 'SuZhou',
    code: '54',
    postalCode: '215000',
    carrierCode: 'HERC',
    hubCode: 'H254',
    leadTime: '1',
    leadTimeDays: '1 day',
    leadTimeAirHours: '#N/A',
    province: '江苏',
    region: '100'
  },
  {
    cityName: '泰安',
    cityNameTraditional: '泰安',
    normalizedCityName: 'TaiAn',
    code: '148',
    postalCode: '271000',
    carrierCode: 'ROKN',
    hubCode: 'H297',
    leadTime: '3',
    leadTimeDays: '3 days',
    leadTimeAirHours: '48',
    province: '山东',
    region: '120'
  },
  {
    cityName: '太仓',
    cityNameTraditional: '太倉',
    normalizedCityName: 'TaiCang',
    code: '55',
    postalCode: '215400',
    carrierCode: 'HERC',
    hubCode: 'H255',
    leadTime: '1',
    leadTimeDays: '1 day',
    leadTimeAirHours: '#N/A',
    province: '江苏',
    region: '100'
  },
  {
    cityName: '泰州',
    cityNameTraditional: '泰州',
    normalizedCityName: 'Taiizhou',
    code: '147',
    postalCode: '225300',
    carrierCode: 'HERC',
    hubCode: 'H296',
    leadTime: '2',
    leadTimeDays: '2 days',
    leadTimeAirHours: '#N/A',
    province: '江苏',
    region: '100'
  },
  {
    cityName: '太原',
    cityNameTraditional: '太原',
    normalizedCityName: 'TaiYuan',
    code: '56',
    postalCode: '030000',
    carrierCode: 'ROKN',
    hubCode: 'H545',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '36',
    province: '山西',
    region: '050'
  },
  {
    cityName: '台州',
    cityNameTraditional: '台州',
    normalizedCityName: 'TaiZhou',
    code: '57',
    postalCode: '318000',
    carrierCode: 'RUBO',
    hubCode: 'H271',
    leadTime: '2',
    leadTimeDays: '2 days',
    leadTimeAirHours: '#N/A',
    province: '浙江',
    region: '130'
  },
  {
    cityName: '唐山',
    cityNameTraditional: '唐山',
    normalizedCityName: 'TangShan',
    code: '58',
    postalCode: '063000',
    carrierCode: 'ROKN',
    hubCode: 'H526',
    leadTime: '3',
    leadTimeDays: '3 days',
    leadTimeAirHours: '48',
    province: '河北',
    region: '060'
  },
  {
    cityName: '天津',
    cityNameTraditional: '天津',
    normalizedCityName: 'TianJin',
    code: '59',
    postalCode: '300000',
    carrierCode: 'ROKN',
    hubCode: 'H548',
    leadTime: '3',
    leadTimeDays: '3 days',
    leadTimeAirHours: '36',
    province: '天津',
    region: '030'
  },
  {
    cityName: '铁岭',
    cityNameTraditional: '鐵嶺',
    normalizedCityName: 'Tieling',
    code: '151',
    postalCode: '112000',
    carrierCode: 'RUBO',
    hubCode: 'H300',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '48',
    province: '辽宁',
    region: '070'
  },
  {
    cityName: '通辽',
    cityNameTraditional: '通遼',
    normalizedCityName: 'Tongliao',
    code: '128',
    postalCode: '028000',
    carrierCode: 'RUBO',
    hubCode: 'H535',
    leadTime: '7',
    leadTimeDays: '7 days',
    leadTimeAirHours: '48',
    province: '内蒙古',
    region: '040'
  },
  {
    cityName: '万宁',
    cityNameTraditional: '萬寧',
    normalizedCityName: 'Wanning',
    code: '176',
    postalCode: '571500',
    carrierCode: 'HERC',
    hubCode: 'H387',
    leadTime: '7',
    leadTimeDays: '7 days',
    leadTimeAirHours: '48',
    province: '海南',
    region: '200'
  },
  {
    cityName: '潍坊',
    cityNameTraditional: '濰坊',
    normalizedCityName: 'WeiFang',
    code: '60',
    postalCode: '261000',
    carrierCode: 'ROKN',
    hubCode: 'H541',
    leadTime: '3',
    leadTimeDays: '3 days',
    leadTimeAirHours: '48',
    province: '山东',
    region: '120'
  },
  {
    cityName: '威海',
    cityNameTraditional: '威海',
    normalizedCityName: 'WeiHai',
    code: '61',
    postalCode: '264200',
    carrierCode: 'ROKN',
    hubCode: 'H542',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '山东',
    region: '120'
  },
  {
    cityName: '文山',
    cityNameTraditional: '文山',
    normalizedCityName: 'Wenshan',
    code: '150',
    postalCode: '663000',
    carrierCode: 'YUHA',
    hubCode: 'H299',
    leadTime: '8',
    leadTimeDays: '8 days',
    leadTimeAirHours: '48',
    province: '云南',
    region: '240'
  },
  {
    cityName: '温州',
    cityNameTraditional: '溫州',
    normalizedCityName: 'WenZhou',
    code: '62',
    postalCode: '325000',
    carrierCode: 'RUBO',
    hubCode: 'H272',
    leadTime: '2',
    leadTimeDays: '2 days',
    leadTimeAirHours: '#N/A',
    province: '浙江',
    region: '130'
  },
  {
    cityName: '吴川',
    cityNameTraditional: '吳川',
    normalizedCityName: 'WuChuan',
    code: '63',
    postalCode: '524500',
    carrierCode: 'HERC',
    hubCode: 'H164',
    leadTime: '6',
    leadTimeDays: '6 days',
    leadTimeAirHours: '48',
    province: '广东',
    region: '190'
  },
  {
    cityName: '五大连池',
    cityNameTraditional: '五大連池',
    normalizedCityName: 'WuDaLianChi',
    code: '95',
    postalCode: '164100',
    carrierCode: 'RUBO',
    hubCode: 'H566',
    leadTime: '6',
    leadTimeDays: '6 days',
    leadTimeAirHours: '48',
    province: '黑龙江',
    region: '090'
  },
  {
    cityName: '乌海',
    cityNameTraditional: '烏海',
    normalizedCityName: 'WuHai',
    code: '110',
    postalCode: '016000',
    carrierCode: 'RUBO',
    hubCode: 'H533',
    leadTime: '10',
    leadTimeDays: '10 days',
    leadTimeAirHours: '48',
    province: '内蒙古',
    region: '040'
  },
  {
    cityName: '武汉',
    cityNameTraditional: '武漢',
    normalizedCityName: 'WuHan',
    code: '64',
    postalCode: '430000',
    carrierCode: 'YUHA',
    hubCode: 'H313',
    leadTime: '3',
    leadTimeDays: '3 days',
    leadTimeAirHours: '36',
    province: '湖北',
    region: '170'
  },
  {
    cityName: '芜湖',
    cityNameTraditional: '蕪湖',
    normalizedCityName: 'Wuhu',
    code: '114',
    postalCode: '241000',
    carrierCode: 'ROKN',
    hubCode: 'H247',
    leadTime: '2',
    leadTimeDays: '2 days',
    leadTimeAirHours: '#N/A',
    province: '安徽',
    region: '110'
  },
  {
    cityName: '吴江',
    cityNameTraditional: '吳江',
    normalizedCityName: 'Wujiang',
    code: '169',
    postalCode: '215200',
    carrierCode: 'HERC',
    hubCode: 'H379',
    leadTime: '1',
    leadTimeDays: '1 day',
    leadTimeAirHours: '#N/A',
    province: '江苏',
    region: '100'
  },
  {
    cityName: '乌鲁木齐',
    cityNameTraditional: '烏魯木齊',
    normalizedCityName: 'WuLuMuQi',
    code: '65',
    postalCode: '830000',
    carrierCode: 'RUBO',
    hubCode: 'H549',
    leadTime: '8',
    leadTimeDays: '8 days',
    leadTimeAirHours: '36',
    province: '新疆',
    region: '290'
  },
  {
    cityName: '无锡',
    cityNameTraditional: '無錫',
    normalizedCityName: 'WuXi',
    code: '66',
    postalCode: '214000',
    carrierCode: 'HERC',
    hubCode: 'H256',
    leadTime: '1',
    leadTimeDays: '1 day',
    leadTimeAirHours: '#N/A',
    province: '江苏',
    region: '100'
  },
  {
    cityName: '厦门',
    cityNameTraditional: '廈門',
    normalizedCityName: 'XiaMen',
    code: '67',
    postalCode: '361000',
    carrierCode: 'ROKN',
    hubCode: 'H582',
    leadTime: '3',
    leadTimeDays: '3 days',
    leadTimeAirHours: '36',
    province: '福建',
    region: '150'
  },
  {
    cityName: '西安',
    cityNameTraditional: '西安',
    normalizedCityName: 'XiAn',
    code: '68',
    postalCode: '710000',
    carrierCode: 'RUBO',
    hubCode: 'H547',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '36',
    province: '陕西',
    region: '250'
  },
  {
    cityName: '襄樊',
    cityNameTraditional: '襄樊',
    normalizedCityName: 'Xiangfan',
    code: '125',
    postalCode: '441000',
    carrierCode: 'YUHA',
    hubCode: 'H317',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '湖北',
    region: '170'
  },
  {
    cityName: '香河',
    cityNameTraditional: '香河',
    normalizedCityName: 'XiangHe',
    code: '99',
    postalCode: '065400',
    carrierCode: 'ROKN',
    hubCode: 'H530',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '48',
    province: '河北',
    region: '060'
  },
  {
    cityName: '湘潭',
    cityNameTraditional: '湘潭',
    normalizedCityName: 'XiangTan',
    code: '108',
    postalCode: '411100',
    carrierCode: 'ROKN',
    hubCode: 'H588',
    leadTime: '3',
    leadTimeDays: '3 days',
    leadTimeAirHours: '48',
    province: '湖南',
    region: '160'
  },
  {
    cityName: '仙桃',
    cityNameTraditional: '仙桃',
    normalizedCityName: 'Xiantao',
    code: '116',
    postalCode: '433000',
    carrierCode: 'YUHA',
    hubCode: 'H315',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '湖北',
    region: '170'
  },
  {
    cityName: '萧山',
    cityNameTraditional: '蕭山',
    normalizedCityName: 'XiaoShan',
    code: '69',
    postalCode: '311200',
    carrierCode: 'RUBO',
    hubCode: 'H273',
    leadTime: '1',
    leadTimeDays: '1 day',
    leadTimeAirHours: '#N/A',
    province: '浙江',
    region: '130'
  },
  {
    cityName: '邢台',
    cityNameTraditional: '邢台',
    normalizedCityName: 'Xingtai',
    code: '143',
    postalCode: '054000',
    carrierCode: 'ROKN',
    hubCode: 'H292',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '河北',
    region: '060'
  },
  {
    cityName: '新会',
    cityNameTraditional: '新會',
    normalizedCityName: 'XinHui',
    code: '23',
    postalCode: '529100',
    carrierCode: 'HERC',
    hubCode: 'H158',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '48',
    province: '广东',
    region: '190'
  },
  {
    cityName: '西宁',
    cityNameTraditional: '西寧',
    normalizedCityName: 'XiNing',
    code: '70',
    postalCode: '810000',
    carrierCode: 'RUBO',
    hubCode: 'H537',
    leadTime: '6',
    leadTimeDays: '6 days',
    leadTimeAirHours: '36',
    province: '青海',
    region: '280'
  },
  {
    cityName: '新乡',
    cityNameTraditional: '新鄉',
    normalizedCityName: 'Xinxiang',
    code: '135',
    postalCode: '453000',
    carrierCode: 'ROKN',
    hubCode: 'H285',
    leadTime: '2',
    leadTimeDays: '2 days',
    leadTimeAirHours: '#N/A',
    province: '河南',
    region: '180'
  },
  {
    cityName: '信阳',
    cityNameTraditional: '信陽',
    normalizedCityName: 'Xinyang',
    code: '153',
    postalCode: '464000',
    carrierCode: 'ROKN',
    hubCode: 'H362',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '48',
    province: '河南',
    region: '180'
  },
  {
    cityName: '锡山',
    cityNameTraditional: '錫山',
    normalizedCityName: 'XiShan',
    code: '71',
    postalCode: '214100',
    carrierCode: 'HERC',
    hubCode: 'H257',
    leadTime: '2',
    leadTimeDays: '2 days',
    leadTimeAirHours: '#N/A',
    province: '江苏',
    region: '100'
  },
  {
    cityName: '许昌',
    cityNameTraditional: '許昌',
    normalizedCityName: 'Xuchang',
    code: '154',
    postalCode: '461000',
    carrierCode: 'ROKN',
    hubCode: 'H363',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '河南',
    region: '180'
  },
  {
    cityName: '徐州',
    cityNameTraditional: '徐州',
    normalizedCityName: 'XuZhou',
    code: '72',
    postalCode: '221000',
    carrierCode: 'HERC',
    hubCode: 'H258',
    leadTime: '2',
    leadTimeDays: '2 days',
    leadTimeAirHours: '#N/A',
    province: '江苏',
    region: '100'
  },
  {
    cityName: '盐城',
    cityNameTraditional: '鹽城',
    normalizedCityName: 'YanCheng',
    code: '137',
    postalCode: '224000',
    carrierCode: 'HERC',
    hubCode: 'H263',
    leadTime: '2',
    leadTimeDays: '2 days',
    leadTimeAirHours: '#N/A',
    province: '江苏',
    region: '100'
  },
  {
    cityName: '扬州',
    cityNameTraditional: '揚州',
    normalizedCityName: 'Yangzhou',
    code: '119',
    postalCode: '225000',
    carrierCode: 'HERC',
    hubCode: 'H262',
    leadTime: '2',
    leadTimeDays: '2 days',
    leadTimeAirHours: '#N/A',
    province: '江苏',
    region: '100'
  },
  {
    cityName: '延吉',
    cityNameTraditional: '延吉',
    normalizedCityName: 'YanJi',
    code: '91',
    postalCode: '133000',
    carrierCode: 'RUBO',
    hubCode: 'H569',
    leadTime: '6',
    leadTimeDays: '6 days',
    leadTimeAirHours: '48',
    province: '吉林',
    region: '080'
  },
  {
    cityName: '烟台',
    cityNameTraditional: '煙台',
    normalizedCityName: 'YanTai',
    code: '73',
    postalCode: '264000',
    carrierCode: 'ROKN',
    hubCode: 'H543',
    leadTime: '3',
    leadTimeDays: '3 days',
    leadTimeAirHours: '48',
    province: '山东',
    region: '120'
  },
  {
    cityName: '宜昌',
    cityNameTraditional: '宜昌',
    normalizedCityName: 'YiChang',
    code: '74',
    postalCode: '443000',
    carrierCode: 'YUHA',
    hubCode: 'H314',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '36',
    province: '湖北',
    region: '170'
  },
  {
    cityName: '银川',
    cityNameTraditional: '銀川',
    normalizedCityName: 'YinChuan',
    code: '75',
    postalCode: '750000',
    carrierCode: 'RUBO',
    hubCode: 'H536',
    leadTime: '6',
    leadTimeDays: '6 days',
    leadTimeAirHours: '36',
    province: '宁夏',
    region: '270'
  },
  {
    cityName: '营口',
    cityNameTraditional: '營口',
    normalizedCityName: 'YingKou',
    code: '76',
    postalCode: '115000',
    carrierCode: 'RUBO',
    hubCode: 'H574',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '48',
    province: '辽宁',
    region: '070'
  },
  {
    cityName: '义乌',
    cityNameTraditional: '義烏',
    normalizedCityName: 'YiWu',
    code: '77',
    postalCode: '322000',
    carrierCode: 'RUBO',
    hubCode: 'H274',
    leadTime: '1',
    leadTimeDays: '1 day',
    leadTimeAirHours: '#N/A',
    province: '浙江',
    region: '130'
  },
  {
    cityName: '宜兴',
    cityNameTraditional: '宜興',
    normalizedCityName: 'Yixing',
    code: '165',
    postalCode: '214200',
    carrierCode: 'HERC',
    hubCode: 'H375',
    leadTime: '2',
    leadTimeDays: '2 days',
    leadTimeAirHours: '#N/A',
    province: '江苏',
    region: '100'
  },
  {
    cityName: '益阳',
    cityNameTraditional: '益陽',
    normalizedCityName: 'Yiyang',
    code: '133',
    postalCode: '413000',
    carrierCode: 'ROKN',
    hubCode: 'H593',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '48',
    province: '湖南',
    region: '160'
  },
  {
    cityName: '岳阳',
    cityNameTraditional: '岳陽',
    normalizedCityName: 'Yueyang',
    code: '130',
    postalCode: '414000',
    carrierCode: 'ROKN',
    hubCode: 'H590',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '湖南',
    region: '160'
  },
  {
    cityName: '玉林',
    cityNameTraditional: '玉林',
    normalizedCityName: 'Yulin',
    code: '171',
    postalCode: '537000',
    carrierCode: 'ROKN',
    hubCode: 'H381',
    leadTime: '6',
    leadTimeDays: '6 days',
    leadTimeAirHours: '48',
    province: '广西',
    region: '210'
  },
  {
    cityName: '玉溪',
    cityNameTraditional: '玉溪',
    normalizedCityName: 'Yuxi',
    code: '166',
    postalCode: '651100',
    carrierCode: 'YUHA',
    hubCode: 'H376',
    leadTime: '7',
    leadTimeDays: '7 days',
    leadTimeAirHours: '48',
    province: '云南',
    region: '240'
  },
  {
    cityName: '增城',
    cityNameTraditional: '增城',
    normalizedCityName: 'ZengCheng',
    code: '78',
    postalCode: '511300',
    carrierCode: 'HERC',
    hubCode: 'H165',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '广东',
    region: '190'
  },
  {
    cityName: '漳州',
    cityNameTraditional: '漳州',
    normalizedCityName: 'ZhangZhou',
    code: '79',
    postalCode: '363000',
    carrierCode: 'ROKN',
    hubCode: 'H583',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '48',
    province: '福建',
    region: '150'
  },
  {
    cityName: '湛江',
    cityNameTraditional: '湛江',
    normalizedCityName: 'ZhanJiang',
    code: '80',
    postalCode: '524000',
    carrierCode: 'HERC',
    hubCode: 'H166',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '广东',
    region: '190'
  },
  {
    cityName: '郑州',
    cityNameTraditional: '鄭州',
    normalizedCityName: 'ZhengZhou',
    code: '81',
    postalCode: '450000',
    carrierCode: 'ROKN',
    hubCode: 'H283',
    leadTime: '3',
    leadTimeDays: '3 days',
    leadTimeAirHours: '36',
    province: '河南',
    region: '180'
  },
  {
    cityName: '镇江',
    cityNameTraditional: '鎮江',
    normalizedCityName: 'Zhenjiang',
    code: '141',
    postalCode: '212000',
    carrierCode: 'HERC',
    hubCode: 'H289',
    leadTime: '1',
    leadTimeDays: '1 day',
    leadTimeAirHours: '#N/A',
    province: '江苏',
    region: '100'
  },
  {
    cityName: '中山',
    cityNameTraditional: '中山',
    normalizedCityName: 'ZhongShan',
    code: '82',
    postalCode: '528400',
    carrierCode: 'HERC',
    hubCode: 'H167',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '广东',
    region: '190'
  },
  {
    cityName: '珠海',
    cityNameTraditional: '珠海',
    normalizedCityName: 'ZhuHai',
    code: '83',
    postalCode: '519000',
    carrierCode: 'HERC',
    hubCode: 'H168',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '广东',
    region: '190'
  },
  {
    cityName: '涿州',
    cityNameTraditional: '涿州',
    normalizedCityName: 'Zhuozhou',
    code: '144',
    postalCode: '072750',
    carrierCode: 'ROKN',
    hubCode: 'H293',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '河北',
    region: '060'
  },
  {
    cityName: '株洲',
    cityNameTraditional: '株洲',
    normalizedCityName: 'Zhuzhou',
    code: '127',
    postalCode: '412000',
    carrierCode: 'ROKN',
    hubCode: 'H589',
    leadTime: '3',
    leadTimeDays: '3 days',
    leadTimeAirHours: '48',
    province: '湖南',
    region: '160'
  },
  {
    cityName: '淄博',
    cityNameTraditional: '淄博',
    normalizedCityName: 'ZiBo',
    code: '84',
    postalCode: '255000',
    carrierCode: 'ROKN',
    hubCode: 'H544',
    leadTime: '3',
    leadTimeDays: '3 days',
    leadTimeAirHours: '48',
    province: '山东',
    region: '120'
  },
  {
    cityName: '自贡',
    cityNameTraditional: '自貢',
    normalizedCityName: 'Zigong',
    code: '183',
    postalCode: '643000',
    carrierCode: 'HERC',
    hubCode: 'H392',
    leadTime: '6',
    leadTimeDays: '6 days',
    leadTimeAirHours: '48',
    province: '四川',
    region: '230'
  },
  {
    cityName: '本溪',
    cityNameTraditional: '本溪',
    normalizedCityName: 'Benxi',
    code: '184',
    postalCode: '117000',
    carrierCode: 'RUBO',
    hubCode: 'H393',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '48',
    province: '辽宁',
    region: '070'
  },
  {
    cityName: '咸阳',
    cityNameTraditional: '咸陽',
    normalizedCityName: 'Xianyang',
    code: '185',
    postalCode: '712000',
    carrierCode: 'RUBO',
    hubCode: 'H395',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '48',
    province: '陕西',
    region: '250'
  },
  {
    cityName: '张家口',
    cityNameTraditional: '張家口',
    normalizedCityName: 'Zhangjiakou',
    code: '187',
    postalCode: '075000',
    carrierCode: 'ROKN',
    hubCode: 'H397',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '河北',
    region: '060'
  },
  {
    cityName: '临潼',
    cityNameTraditional: '臨潼',
    normalizedCityName: 'Lintong',
    code: '186',
    postalCode: '710600',
    carrierCode: 'RUBO',
    hubCode: 'H396',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '48',
    province: '陕西',
    region: '250'
  },
  {
    cityName: '连江县',
    cityNameTraditional: '連江縣',
    normalizedCityName: 'Lianjiang',
    code: '188',
    postalCode: '350500',
    carrierCode: 'ROKN',
    hubCode: 'H400',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '福建',
    region: '150'
  },
  {
    cityName: '宁乡县',
    cityNameTraditional: '寧鄉縣',
    normalizedCityName: 'Ningxiang',
    code: '189',
    postalCode: '410600',
    carrierCode: 'ROKN',
    hubCode: 'H401',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '湖南',
    region: '160'
  },
  {
    cityName: '鹿泉',
    cityNameTraditional: '鹿泉',
    normalizedCityName: 'Luquan',
    code: '190',
    postalCode: '050200',
    carrierCode: 'ROKN',
    hubCode: 'H402',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '河北',
    region: '060'
  },
  {
    cityName: '安宁',
    cityNameTraditional: '安寧',
    normalizedCityName: 'Anning',
    code: '192',
    postalCode: '650300',
    carrierCode: 'YUHA',
    hubCode: 'H404',
    leadTime: '7',
    leadTimeDays: '7 days',
    leadTimeAirHours: '48',
    province: '云南',
    region: '240'
  },
  {
    cityName: '宝鸡',
    cityNameTraditional: '寶雞',
    normalizedCityName: 'Baoji',
    code: '193',
    postalCode: '721000',
    carrierCode: 'RUBO',
    hubCode: 'H405',
    leadTime: '6',
    leadTimeDays: '6 days',
    leadTimeAirHours: '48',
    province: '陕西',
    region: '250'
  },
  {
    cityName: '榆林',
    cityNameTraditional: '榆林',
    normalizedCityName: 'Yulin',
    code: '194',
    postalCode: '719000',
    carrierCode: 'RUBO',
    hubCode: 'H406',
    leadTime: '6',
    leadTimeDays: '6 days',
    leadTimeAirHours: '48',
    province: '陕西',
    region: '250'
  },
  {
    cityName: '延安',
    cityNameTraditional: '延安',
    normalizedCityName: 'Yanan',
    code: '195',
    postalCode: '716000',
    carrierCode: 'RUBO',
    hubCode: 'H407',
    leadTime: '6',
    leadTimeDays: '6 days',
    leadTimeAirHours: '48',
    province: '陕西',
    region: '250'
  },
  {
    cityName: '侯马',
    cityNameTraditional: '侯馬',
    normalizedCityName: 'Houma',
    code: '196',
    postalCode: '043099',
    carrierCode: 'ROKN',
    hubCode: 'H408',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '48',
    province: '山西',
    region: '050'
  },
  {
    cityName: '晋中',
    cityNameTraditional: '晉中',
    normalizedCityName: 'Jinzhong',
    code: '197',
    postalCode: '030699',
    carrierCode: 'ROKN',
    hubCode: 'H409',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '48',
    province: '山西',
    region: '050'
  },
  {
    cityName: '遵义',
    cityNameTraditional: '遵義',
    normalizedCityName: 'Zunyi',
    code: '199',
    postalCode: '563099',
    carrierCode: 'YUHA',
    hubCode: 'H414',
    leadTime: '7',
    leadTimeDays: '7 days',
    leadTimeAirHours: '48',
    province: '贵州',
    region: '220'
  },
  {
    cityName: '舟山',
    cityNameTraditional: '舟山',
    normalizedCityName: 'Zhoushan',
    code: '198',
    postalCode: '316099',
    carrierCode: 'RUBO',
    hubCode: 'H412',
    leadTime: '3',
    leadTimeDays: '3 days',
    leadTimeAirHours: '48',
    province: '浙江',
    region: '130'
  },
  {
    cityName: '拉萨',
    cityNameTraditional: '拉薩',
    normalizedCityName: 'Lhasa',
    code: '204',
    postalCode: '860000',
    carrierCode: 'YUHA',
    hubCode: 'H419',
    leadTime: '8',
    leadTimeDays: '8 days',
    leadTimeAirHours: '48',
    province: '西藏',
    region: '300'
  },
  {
    cityName: '林芝',
    cityNameTraditional: '林芝',
    normalizedCityName: 'Linzhi',
    code: '207',
    postalCode: '860000',
    carrierCode: 'YUHA',
    hubCode: 'H418',
    leadTime: '12',
    leadTimeDays: '12 days',
    leadTimeAirHours: '72',
    province: '西藏',
    region: '300'
  },
  {
    cityName: '温岭',
    cityNameTraditional: '溫嶺',
    normalizedCityName: 'Wenling',
    code: '200',
    postalCode: '317500',
    carrierCode: 'RUBO',
    hubCode: 'H421',
    leadTime: '2',
    leadTimeDays: '2 days',
    leadTimeAirHours: '48',
    province: '浙江',
    region: '130'
  },
  {
    cityName: '滨海',
    cityNameTraditional: '濱海',
    normalizedCityName: 'Binhai',
    code: '201',
    postalCode: '224500',
    carrierCode: 'HERC',
    hubCode: 'H420',
    leadTime: '3',
    leadTimeDays: '3 days',
    leadTimeAirHours: '48',
    province: '江苏',
    region: '100'
  },
  {
    cityName: '乌兰浩特',
    cityNameTraditional: '烏蘭浩特',
    normalizedCityName: 'Wulanhaote',
    code: '202',
    postalCode: '137400',
    carrierCode: 'RUBO',
    hubCode: 'H415',
    leadTime: '8',
    leadTimeDays: '8 days',
    leadTimeAirHours: '60',
    province: '内蒙古',
    region: '040'
  },
  {
    cityName: '长治',
    cityNameTraditional: '長治',
    normalizedCityName: 'Changzhi',
    code: '203',
    postalCode: '046000',
    carrierCode: 'ROKN',
    hubCode: 'H423',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '48',
    province: '山西',
    region: '050'
  },
  {
    cityName: '晋城',
    cityNameTraditional: '晉城',
    normalizedCityName: 'Jincheng',
    code: '204',
    postalCode: '048000',
    carrierCode: 'ROKN',
    hubCode: 'H422',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '48',
    province: '山西',
    region: '050'
  },
  {
    cityName: '临汾',
    cityNameTraditional: '臨汾',
    normalizedCityName: 'Linfen',
    code: '205',
    postalCode: '041000',
    carrierCode: 'ROKN',
    hubCode: 'H425',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '48',
    province: '山西',
    region: '050'
  },
  {
    cityName: '诸暨',
    cityNameTraditional: '諸暨',
    normalizedCityName: 'Zhuji',
    code: '207',
    postalCode: '311800',
    carrierCode: 'RUBO',
    hubCode: 'H430',
    leadTime: '2',
    leadTimeDays: '2 days',
    leadTimeAirHours: '48',
    province: '浙江',
    region: '130'
  },
  {
    cityName: '铜陵',
    cityNameTraditional: '銅陵',
    normalizedCityName: 'Tongling',
    code: '208',
    postalCode: '244000',
    carrierCode: 'ROKN',
    hubCode: 'H426',
    leadTime: '3',
    leadTimeDays: '3 days',
    leadTimeAirHours: '48',
    province: '安徽',
    region: '110'
  },
  {
    cityName: '衢州',
    cityNameTraditional: '衢州',
    normalizedCityName: 'Quzhou',
    code: '209',
    postalCode: '324000',
    carrierCode: 'RUBO',
    hubCode: 'H427',
    leadTime: '2',
    leadTimeDays: '2 days',
    leadTimeAirHours: '48',
    province: '浙江',
    region: '130'
  },
  {
    cityName: '丹东',
    cityNameTraditional: '丹東',
    normalizedCityName: 'Dandong',
    code: '210',
    postalCode: '118000',
    carrierCode: 'RUBO',
    hubCode: 'H431',
    leadTime: '5',
    leadTimeDays: '5 days',
    leadTimeAirHours: '60',
    province: '辽宁',
    region: '070'
  },
  {
    cityName: '驻马店',
    cityNameTraditional: '駐馬店',
    normalizedCityName: 'Zhumadian',
    code: '211',
    postalCode: '463000',
    carrierCode: 'ROKN',
    hubCode: 'H429',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '河南',
    region: '180'
  },
  {
    cityName: '赣州',
    cityNameTraditional: '贛州',
    normalizedCityName: 'Ganzhou',
    code: '212',
    postalCode: '341000',
    carrierCode: 'ROKN',
    hubCode: 'H416',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '江西',
    region: '140'
  },
  {
    cityName: '梅河口',
    cityNameTraditional: '梅河口',
    normalizedCityName: 'Meihekou',
    code: '213',
    postalCode: '135000',
    carrierCode: 'RUBO',
    hubCode: 'H438',
    leadTime: '8',
    leadTimeDays: '8 days',
    leadTimeAirHours: '72',
    province: '吉林',
    region: '080'
  },
  {
    cityName: '嵊州',
    cityNameTraditional: '嵊州',
    normalizedCityName: 'Shengzhou',
    code: '214',
    postalCode: '312400',
    carrierCode: 'RUBO',
    hubCode: 'H439',
    leadTime: '2',
    leadTimeDays: '2 days',
    leadTimeAirHours: '48',
    province: '浙江',
    region: '130'
  },
  {
    cityName: '汉中',
    cityNameTraditional: '漢中',
    normalizedCityName: 'Hanzhong',
    code: '215',
    postalCode: '723000',
    carrierCode: 'RUBO',
    hubCode: 'H444',
    leadTime: '9',
    leadTimeDays: '9 days',
    leadTimeAirHours: '72',
    province: '陕西',
    region: '250'
  },
  {
    cityName: '肇庆',
    cityNameTraditional: '肇慶',
    normalizedCityName: 'Zhaoqing',
    code: '216',
    postalCode: '526000',
    carrierCode: 'HERC',
    hubCode: 'H445',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '广东',
    region: '190'
  },
  {
    cityName: '凤城',
    cityNameTraditional: '鳳城',
    normalizedCityName: 'Fengcheng',
    code: '217',
    postalCode: '118100',
    carrierCode: 'RUBO',
    hubCode: 'H446',
    leadTime: '7',
    leadTimeDays: '7 days',
    leadTimeAirHours: '48',
    province: '辽宁',
    region: '070'
  },
  {
    cityName: '日照',
    cityNameTraditional: '日照',
    normalizedCityName: 'Rizhao',
    code: '218',
    postalCode: '262301',
    carrierCode: 'ROKN',
    hubCode: 'H447',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '山东',
    region: '120'
  },
  {
    cityName: '鄂尔多斯',
    cityNameTraditional: '鄂爾多斯',
    normalizedCityName: 'Eerduosi',
    code: '219',
    postalCode: '017000',
    carrierCode: 'RUBO',
    hubCode: 'H448',
    leadTime: '7',
    leadTimeDays: '7 days',
    leadTimeAirHours: '48',
    province: '内蒙古',
    region: '040'
  },
  {
    cityName: '牙克石',
    cityNameTraditional: '牙克石',
    normalizedCityName: 'Yakeshi',
    code: '220',
    postalCode: '022150',
    carrierCode: 'RUBO',
    hubCode: 'H449',
    leadTime: '12',
    leadTimeDays: '12 days',
    leadTimeAirHours: '48',
    province: '内蒙古',
    region: '040'
  },
  {
    cityName: '德阳',
    cityNameTraditional: '德陽',
    normalizedCityName: 'Deyang',
    code: '221',
    postalCode: '618000',
    carrierCode: 'HERC',
    hubCode: 'H455',
    leadTime: '6',
    leadTimeDays: '6 days',
    leadTimeAirHours: '48',
    province: '四川',
    region: '230'
  },
  {
    cityName: '眉山',
    cityNameTraditional: '眉山',
    normalizedCityName: 'Meishan',
    code: '222',
    postalCode: '620000',
    carrierCode: 'HERC',
    hubCode: 'H456',
    leadTime: '6',
    leadTimeDays: '6 days',
    leadTimeAirHours: '48',
    province: '四川',
    region: '230'
  },
  {
    cityName: '宜宾',
    cityNameTraditional: '宜賓',
    normalizedCityName: 'Yibin',
    code: '223',
    postalCode: '644000',
    carrierCode: 'HERC',
    hubCode: 'H457',
    leadTime: '6',
    leadTimeDays: '6 days',
    leadTimeAirHours: '48',
    province: '四川',
    region: '230'
  },
  {
    cityName: '西昌',
    cityNameTraditional: '西昌',
    normalizedCityName: 'Xichang',
    code: '224',
    postalCode: '615000',
    carrierCode: 'HERC',
    hubCode: 'H458',
    leadTime: '6',
    leadTimeDays: '6 days',
    leadTimeAirHours: '48',
    province: '四川',
    region: '230'
  },
  {
    cityName: '泸州',
    cityNameTraditional: '瀘州',
    normalizedCityName: 'Luzhou',
    code: '225',
    postalCode: '646000',
    carrierCode: 'HERC',
    hubCode: 'H459',
    leadTime: '6',
    leadTimeDays: '6 days',
    leadTimeAirHours: '48',
    province: '四川',
    region: '230'
  },
  {
    cityName: '达州',
    cityNameTraditional: '達州',
    normalizedCityName: 'Dazhou',
    code: '226',
    postalCode: '635000',
    carrierCode: 'HERC',
    hubCode: 'H461',
    leadTime: '9',
    leadTimeDays: '6 days',
    leadTimeAirHours: '48',
    province: '四川',
    region: '230'
  },
  {
    cityName: '南充',
    cityNameTraditional: '南充',
    normalizedCityName: 'Nanchong',
    code: '227',
    postalCode: '637000',
    carrierCode: 'HERC',
    hubCode: 'H462',
    leadTime: '6',
    leadTimeDays: '6 days',
    leadTimeAirHours: '48',
    province: '四川',
    region: '230'
  },
  {
    cityName: '乐山',
    cityNameTraditional: '樂山',
    normalizedCityName: 'Leshan',
    code: '228',
    postalCode: '614000',
    carrierCode: 'HERC',
    hubCode: 'H464',
    leadTime: '9',
    leadTimeDays: '9 days',
    leadTimeAirHours: '48',
    province: '四川',
    region: '230'
  },
  {
    cityName: '都江堰',
    cityNameTraditional: '都江堰',
    normalizedCityName: 'Dujiangyan',
    code: '229',
    postalCode: '611830',
    carrierCode: 'HERC',
    hubCode: 'H465',
    leadTime: '7',
    leadTimeDays: '7 days',
    leadTimeAirHours: '48',
    province: '四川',
    region: '230'
  },
  {
    cityName: '衡水',
    cityNameTraditional: '衡水',
    normalizedCityName: 'Hengshui',
    code: '230',
    postalCode: '053000',
    carrierCode: 'ROKN',
    hubCode: 'H454',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '河北',
    region: '060'
  },
  {
    cityName: '渭南',
    cityNameTraditional: '渭南',
    normalizedCityName: 'WeiNan',
    code: '231',
    postalCode: '714000',
    carrierCode: 'RUBO',
    hubCode: 'H594',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '陝西',
    region: '250'
  },
  {
    cityName: '攀枝花',
    cityNameTraditional: '攀枝花',
    normalizedCityName: 'PanZhihua',
    code: '232',
    postalCode: '617000',
    carrierCode: 'YUHA',
    hubCode: 'H599',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '四川',
    region: '230'
  },
  {
    cityName: '都匀',
    cityNameTraditional: '都勻',
    normalizedCityName: 'DuYun',
    code: '233',
    postalCode: '558000',
    carrierCode: 'YUHA',
    hubCode: 'H595',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '贵州',
    region: '220'
  },
  {
    cityName: '毕节',
    cityNameTraditional: '畢節',
    normalizedCityName: 'BiJie',
    code: '234',
    postalCode: '551700',
    carrierCode: 'YUHA',
    hubCode: 'H596',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '贵州',
    region: '220'
  },
  {
    cityName: '孝感',
    cityNameTraditional: '孝感',
    normalizedCityName: 'XiaoGan',
    code: '235',
    postalCode: '432000',
    carrierCode: 'YUHA',
    hubCode: 'H597',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '湖北',
    region: '170'
  },
  {
    cityName: '多巴',
    cityNameTraditional: '多巴',
    normalizedCityName: 'DuoBa',
    code: '236',
    postalCode: '811601',
    carrierCode: 'RUBO',
    hubCode: 'H598',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '青海',
    region: '280'
  },
  {
    cityName: '三门峡',
    cityNameTraditional: '三門峽',
    normalizedCityName: 'SanMenxia',
    code: '237',
    postalCode: '472000',
    carrierCode: 'ROKN',
    hubCode: 'H600',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '河南',
    region: '180'
  },
  {
    cityName: '沧州',
    cityNameTraditional: '沧州',
    normalizedCityName: 'Cangzhou',
    code: '238',
    postalCode: '062563',
    carrierCode: 'ROKN',
    hubCode: 'H601',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '河北',
    region: '060'
  },
  {
    cityName: '白山',
    cityNameTraditional: '白山',
    normalizedCityName: 'Baishan',
    code: '240',
    postalCode: '135200',
    carrierCode: 'ROKN',
    hubCode: 'H602',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '吉林',
    region: '080'
  },
  {
    cityName: '安康',
    cityNameTraditional: '安康',
    normalizedCityName: 'Ankang',
    code: '241',
    postalCode: '725800',
    carrierCode: 'RUBO',
    hubCode: 'H603',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '陕西',
    region: '250'
  },
  {
    cityName: '如皋',
    cityNameTraditional: '如皋',
    normalizedCityName: 'Rugao',
    code: '239',
    postalCode: '226500',
    carrierCode: 'YUHA',
    hubCode: 'H604',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '江苏',
    region: '100'
  },
  {
    cityName: '六盘水',
    cityNameTraditional: '六盤水',
    normalizedCityName: 'LiuPanshui',
    code: '242',
    postalCode: '553000',
    carrierCode: 'YUHA',
    hubCode: 'H653',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '贵州',
    region: '220'
  },
  {
    cityName: '兴义',
    cityNameTraditional: '興義',
    normalizedCityName: 'XingYi',
    code: '243',
    postalCode: '562400',
    carrierCode: 'YUHA',
    hubCode: 'H654',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '贵州',
    region: '220'
  },
  {
    cityName: '凯里',
    cityNameTraditional: '凱里',
    normalizedCityName: 'KaiLi',
    code: '244',
    postalCode: '556000',
    carrierCode: 'YUHA',
    hubCode: 'H655',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '贵州',
    region: '220'
  },
  {
    cityName: '十堰',
    cityNameTraditional: '十堰',
    normalizedCityName: 'ShiYan',
    code: '245',
    postalCode: '442000',
    carrierCode: 'YUHA',
    hubCode: 'H652',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '湖北',
    region: '170'
  },
  {
    cityName: '商丘',
    cityNameTraditional: '商丘',
    normalizedCityName: 'ShangQiu',
    code: '246',
    postalCode: '476000',
    carrierCode: 'ROKN',
    hubCode: 'H667',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '河南',
    region: '180'
  },
  {
    cityName: '大理',
    cityNameTraditional: '大理',
    normalizedCityName: 'DaLi',
    code: '247',
    postalCode: '671000',
    carrierCode: 'YUHA',
    hubCode: 'H648',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '云南',
    region: '240'
  },
  {
    cityName: '天水',
    cityNameTraditional: '天水',
    normalizedCityName: 'TianShui',
    code: '248',
    postalCode: '741000',
    carrierCode: 'RUBO',
    hubCode: 'H683',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '甘肃',
    region: '260'
  },
  {
    cityName: '宿州',
    cityNameTraditional: '宿州',
    normalizedCityName: 'suzhou',
    code: '249',
    postalCode: '234000',
    carrierCode: 'ROKN',
    hubCode: 'H656',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '安徽',
    region: '110'
  },
  {
    cityName: '寿光',
    cityNameTraditional: '壽光',
    normalizedCityName: 'ShouGuang',
    code: '250',
    postalCode: '262700',
    carrierCode: 'ROKN',
    hubCode: 'H661',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '山东',
    region: '120'
  },
  {
    cityName: '崇州',
    cityNameTraditional: '崇州',
    normalizedCityName: 'ChongZhou',
    code: '251',
    postalCode: '611200',
    carrierCode: 'YUHA',
    hubCode: 'H650',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '四川',
    region: '230'
  },
  {
    cityName: '开封',
    cityNameTraditional: '開封',
    normalizedCityName: 'KaiFeng',
    code: '252',
    postalCode: '475000',
    carrierCode: 'ROKN',
    hubCode: 'H671',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '河南',
    region: '180'
  },
  {
    cityName: '张家港',
    cityNameTraditional: '張家港',
    normalizedCityName: 'ZhangJiagang',
    code: '253',
    postalCode: '215600',
    carrierCode: 'YUHA',
    hubCode: 'H651',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '江苏',
    region: '100'
  },
  {
    cityName: '张家界',
    cityNameTraditional: '張家界',
    normalizedCityName: 'ZhangJiajie',
    code: '254',
    postalCode: '427000',
    carrierCode: 'ROKN',
    hubCode: 'H673',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '湖南',
    region: '160'
  },
  {
    cityName: '招远',
    cityNameTraditional: '招遠',
    normalizedCityName: 'ZhaoYuan',
    code: '255',
    postalCode: '265400',
    carrierCode: 'ROKN',
    hubCode: 'H659',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '山东',
    region: '120'
  },
  {
    cityName: '昌吉',
    cityNameTraditional: '昌吉',
    normalizedCityName: 'ChangJi',
    code: '256',
    postalCode: '831100',
    carrierCode: 'RUBO',
    hubCode: 'H679',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '新疆',
    region: '290'
  },
  {
    cityName: '曲阜',
    cityNameTraditional: '曲阜',
    normalizedCityName: 'QuFu',
    code: '257',
    postalCode: '236000',
    carrierCode: 'ROKN',
    hubCode: 'H666',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '山东',
    region: '120'
  },
  {
    cityName: '曲靖',
    cityNameTraditional: '曲靖',
    normalizedCityName: 'QuJin',
    code: '258',
    postalCode: '654200',
    carrierCode: 'YUHA',
    hubCode: 'H649',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '云南',
    region: '240'
  },
  {
    cityName: '枣庄',
    cityNameTraditional: '棗莊',
    normalizedCityName: 'ZaoZhuang',
    code: '259',
    postalCode: '277000',
    carrierCode: 'ROKN',
    hubCode: 'H664',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '山东',
    region: '120'
  },
  {
    cityName: '桐乡',
    cityNameTraditional: '桐鄉',
    normalizedCityName: 'TongXiang',
    code: '260',
    postalCode: '314500',
    carrierCode: 'RUBO',
    hubCode: 'H682',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '浙江',
    region: '130'
  },
  {
    cityName: '永康',
    cityNameTraditional: '永康',
    normalizedCityName: 'YongKang',
    code: '261',
    postalCode: '321300',
    carrierCode: 'RUBO',
    hubCode: 'H680',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '浙江',
    region: '130'
  },
  {
    cityName: '濮阳',
    cityNameTraditional: '濮陽',
    normalizedCityName: 'PuYang',
    code: '262',
    postalCode: '457000',
    carrierCode: 'ROKN',
    hubCode: 'H669',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '河南',
    region: '180'
  },
  {
    cityName: '聊城',
    cityNameTraditional: '聊城',
    normalizedCityName: 'LiaoCheng',
    code: '263',
    postalCode: '252000',
    carrierCode: 'ROKN',
    hubCode: 'H663',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '山东',
    region: '120'
  },
  {
    cityName: '苍南',
    cityNameTraditional: '蒼南',
    normalizedCityName: 'CangNan',
    code: '264',
    postalCode: '325800',
    carrierCode: 'RUBO',
    hubCode: 'H681',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '浙江',
    region: '130'
  },
  {
    cityName: '荥阳',
    cityNameTraditional: '滎陽',
    normalizedCityName: 'YingYang',
    code: '265',
    postalCode: '450100',
    carrierCode: 'ROKN',
    hubCode: 'H668',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '河南',
    region: '180'
  },
  {
    cityName: '菏泽',
    cityNameTraditional: '菏澤',
    normalizedCityName: 'HeZe',
    code: '266',
    postalCode: '274000',
    carrierCode: 'ROKN',
    hubCode: 'H665',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '山东',
    region: '120'
  },
  {
    cityName: '诸城',
    cityNameTraditional: '諸城',
    normalizedCityName: 'ZhuCheng',
    code: '267',
    postalCode: '262200',
    carrierCode: 'ROKN',
    hubCode: 'H660',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '山东',
    region: '120'
  },
  {
    cityName: '邵阳',
    cityNameTraditional: '邵陽',
    normalizedCityName: 'ShaoYang',
    code: '268',
    postalCode: '422000',
    carrierCode: 'ROKN',
    hubCode: 'H672',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '湖南',
    region: '160'
  },
  {
    cityName: '阜阳',
    cityNameTraditional: '阜陽',
    normalizedCityName: 'FuYang',
    code: '269',
    postalCode: '236000',
    carrierCode: 'ROKN',
    hubCode: 'H657',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '安徽',
    region: '110'
  },
  {
    cityName: '高密',
    cityNameTraditional: '高密',
    normalizedCityName: 'GaoMi',
    code: '270',
    postalCode: '261500',
    carrierCode: 'ROKN',
    hubCode: 'H658',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '山东',
    region: '120'
  },
  {
    cityName: '龙岩',
    cityNameTraditional: '龍岩',
    normalizedCityName: 'LongYan',
    code: '271',
    postalCode: '364000',
    carrierCode: 'ROKN',
    hubCode: 'H675',
    leadTime: '4',
    leadTimeDays: '4 days',
    leadTimeAirHours: '48',
    province: '福建',
    region: '150'
  }
];
